import Plyr from 'plyr';
import SimpleLightbox from 'simplelightbox';

export default {
  init() {
    if ($('.js-video').length > 0) {
      const players = Array.from(document.querySelectorAll('.js-video')).map((p) => new Plyr(p,
        {
          controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
          youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
        }));

      players.forEach(function (player) {
        player.toggleControls(false)
        player.on('play', () => {
          player.toggleControls(true);
        });
      })

      window.addEventListener('ready', () => {
        //const player = event.detail.plyr;
      });
    }
  },
  finalize() {
    if ($('.js-gallery').length > 0) {
      const lightbox = new SimpleLightbox('.js-gallery a', {
        'navText': ['<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12.427 22.026"><path fill="none" class="stroke-white" stroke-width="2" d="M11.72.707 1.414 11.013 11.72 21.319" data-name="Tracé 239"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12.427 22.025"><path fill="none" class="stroke-white" stroke-width="2" d="m.707.707 10.306 10.305L.707 21.317" data-name="Tracé 238"/></svg>'],
        'showCounter': false,
        'closeText': '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  viewBox="0 0 22.828 22.828"><g fill="none" class="stroke-white" stroke-linecap="round" stroke-width="2" data-name="Groupe 1245"><path d="m1.414 1.414 20 20" data-name="Ligne 9"/><path d="m21.414 1.414-20 20" data-name="Ligne 10"/></g></svg>',
        'nav': true,
      });
      $('.js-open-lightbox').on('click', function () {
        lightbox.open();
      })
    }
  },
};
